import {Col, Row} from "antd";
import styled from "styled-components";

export const InputRowContainer = styled(Row)`
    padding-left: 40px;
    width: 100%;
`;

// Customer-specific compact input row container
export const CustomerInputRowContainer = styled(Row)`
    padding-left: 30px;
    width: 100%;
    margin-bottom: 4px;
`;

export const InputRowTitle = styled(Col)`
    font-size: 18px;
`;

// Customer-specific compact input row title
export const CustomerInputRowTitle = styled(Col)`
    font-size: 16px;
`;
